import { use } from 'react'
import useSWR from 'swr'
import { ClientContext } from '../../client'

export const useFetchPrivilegesSWR = () => {
  const getClient = use(ClientContext)

  return useSWR('fetchPrivileges', async () => {
    const client = await getClient()
    const privileges = await client.FetchPrivileges({})
    return privileges
  })
}
